import { useEffect,useState } from 'react'
import { Link } from 'react-router-dom'
import { useEntityCrud } from '../../../hooks/useEntityCrud'
import Pagination from '../../Common/Pagination'
import ReactSelect from 'react-select'
import InputMask from 'react-input-mask'
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';

const Index = () => {

    const { readData } = useEntityCrud('Support/getSupportRequest')

    const [rows,setRows] = useState([])
    const [pages,setPages] = useState([])
    const [currentPage,setCurrentPage] = useState(1)
    const [lastPage,setLastPage] = useState(0)

    const [requestNo,setRequestNo] = useState('')
    const [nationalCode,setNationalCode] = useState('')
    const [fromDate,setFromDate] = useState('')
    const [toDate,setToDate] = useState('')
    const [businesses,setBusinesses] = useState([])
    const {readData: getBusinesses} = useEntityCrud('Business/GetAllBusiness')
    const [businessId,setBusinessId] = useState(0)
    const [categoryType,setCategoryType] = useState(0)
    const [topics,setTopics] = useState([])
    const {readData: getTopics} = useEntityCrud('Support/getTopics')
    const [topicId,setTopicId] = useState(0)
    const [status,setStatus] = useState(0)
    const [count,setCount] = useState(0);

    const convertToGregorian = date => date.year.toString() + (date.month > 9 ? date.month.toString() : ('0' + date.month)) + (date.day > 9 ? date.day.toString() : ('0' + date.day))

    const getFilterData = () => {
        const postedData = {}
        if(nationalCode)
            postedData.nationalCode = nationalCode
        if(fromDate)
            postedData.insertDateFrom = convertToGregorian(fromDate)
        if(toDate)
            postedData.insertDateTo = convertToGregorian(toDate)
        if(categoryType)
            postedData.categoryType = categoryType
        if(topicId)
            postedData.topicId = topicId
        if(status)
            postedData.status = status
        if(businessId?.value)
            postedData.businessId = businessId.value
        if(requestNo)
            postedData.requestNo = requestNo
        return postedData || {}
    }

    const getData = (withFilter = true) => {
        let postedData = {
            offset: 0,
            limit: 10
        }
        if(withFilter)
            postedData = {
                ...postedData,
                ...getFilterData()
            }
        readData(postedData).then(res => {
            if(res.data.status){
                calcPages(res);
                setRows(res.data.result);
            }else{
                setRows([]);
                setPages([]);
            }
        })
    }

    useEffect(() => {
        getData()
        getBusinesses().then(({data}) => {
            let businessesList = []
            if(data.status)
                data.result.map(b => businessesList.push({
                    label: b.title,
                    isActive: b.isActive,
                    value: b.id
                }))
            setBusinesses(businessesList)
        })
        getTopics().then(({data}) => {
            if(data.status)
                setTopics(data.result)
        })
    },[])

    const calcPages = res => {
        let calcPages = res.data.count / 10;
        setCount(res.data.count)

        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setLastPage(pagesArray.length)
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e,page) => {
        e.preventDefault();
        setCurrentPage(page);
        const postedData = {
            offset: page - 1,
            limit: 10,
            ...getFilterData()
        }
        readData(postedData).then(res => {
            if(res.data.status)
                setRows(res.data.result);
        })
    }

    const prevPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            offset: currentPage - 2,
            limit: 10,
            ...getFilterData()
        }
        readData(postedData).then(res => {
            if(res.data.status){
                calcPages(res);
                setRows(res.data.result);
            }else{
                setRows([]);
                setPages([]);
            }
        })
    }

    const nextPage = e => {
        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            offset: currentPage - 2,
            limit: 10,
            ...getFilterData()
        }
        readData(postedData).then(res => {
            if(res.data.status){
                calcPages(res);
                setRows(res.data.result);
            }else{
                setRows([]);
                setPages([]);
            }
        })
    }

    const filter = () => {
        getData()
    }

    const downloadExcel = () => {
        document.getElementById('btn-excel').classList.add('btn-loading')
        const postedData = {
            ...getFilterData(),
            limit: 0,
            excelOutput: true
        }
        readData(postedData).then(({ data }) => {
            if(data.status)
                window.open(data.excelPath)
        }).finally(() => {
            document.getElementById('btn-excel').classList.remove('btn-loading')
        })
    }

    const reset = () => {
        setRequestNo('')
        setRequestNo('')
        setNationalCode('')
        setFromDate('')
        setToDate('')
        setBusinessId('')
        setCategoryType('')
        setTopicId('')
        setStatus('')
        getData(false)
    }

    return (
        <div className="card">
            <div className="card-header px-4">
                <div className="card-title">لیست تیکت ها</div>
            </div>
            <div className="card-body p-4">
                <div className="row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>شماره درخواست</label>
                            <input type="tel" className="form-control ltr-input" maxLength={6} value={requestNo} onChange={e => setRequestNo(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group position-relative" style={{zIndex: 2}}>
                            <label>کسب و کار</label>
                            <ReactSelect
                                options={businesses.filter(item => item.isActive)}
                                value={businessId}
                                onChange={value => setBusinessId(value)}
                                isClearable
                                placeholder="انتخاب کنید"
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>نوع</label>
                            <select className="form-control" onChange={e => setCategoryType(e.target.value)} value={categoryType}>
                                <option value="">انتخاب کنید</option>
                                <option value="1">شکایت</option>
                                <option value="2">پشتیبانی</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>موضوع</label>
                            <select className="form-control" onChange={e => setTopicId(e.target.value)} value={topicId}>
                                <option value="">انتخاب کنید</option>
                                {topics.filter(t => (categoryType == 1 && t.criticism) || (categoryType == 2 && !t.criticism)).map(topic => <option key={topic.id} value={topic.id}>{topic.title}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>وضعیت</label>
                            <select className="form-control" onChange={e => setStatus(e.target.value)} value={status}>
                                <option value="">انتخاب کنید</option>
                                <option value="1">ثبت شده</option>
                                <option value="2">پاسخ داده شده</option>
                                <option value="3">بسته شده</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>کد ملی</label>
                            <InputMask mask="9999999999" className="form-control ltr-input" onChange={e => setNationalCode(e.target.value)} />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>از تاریخ</label>
                            {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                            <DatePicker
                                locale="fa"
                                shouldHighlightWeekends
                                value={fromDate}
                                onChange={setFromDate}
                                className="form-control my-1 pb-4"
                            />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>تا تاریخ</label>
                            {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                            <DatePicker
                                locale="fa"
                                shouldHighlightWeekends
                                value={toDate}
                                onChange={setToDate}
                                className="form-control my-1 pb-4"
                            />
                        </div>
                    </div>
                    <div className="col-md-12 mb-4">
                        <button className="btn btn-primary me-2" onClick={filter}>جستجو</button>
                        <button className="btn btn-success me-2" id="btn-excel" onClick={downloadExcel}>دریافت خروجی اکسل</button>
                        <button className="btn btn-danger" onClick={reset}>بازنشانی</button>
                    </div>
                </div>
                {rows.length ? <div className="table-responsive">
                    <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>شماره درخواست</th>
                                <th>نام و نام خانوادگی</th>
                                <th>کد ملی</th>
                                <th>نوع</th>
                                <th>موضوع</th>
                                <th>کسب و کار</th>
                                <th>وضعیت</th>
                                <th>تاریخ ثبت</th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((row,index) => <tr key={row.id}>
                                <td>{(index + 1) + (currentPage > 1 ? (currentPage - 1) * 10 : '')}</td>
                                <td>{row.requestNo}</td>
                                <td>{row.issuerFullName}</td>
                                <td>{row.nationalCode}</td>
                                <td>{row.categoryType == 1 ? 'شکایت' : 'پشتیبانی'}</td>
                                <td>{row.topicTitle}</td>
                                <td>{row.businessName || '-'}</td>
                                <td>{row.statusTitle}</td>
                                <td>{new Date(row.insertDate).toLocaleDateString('fa-IR')}</td>
                                <td>
                                    <Link to={`/tickets/view/${row.id}`} className="btn btn-icon mb-0 btn-primary" title="مشاهده"><i className="fe fe-eye"></i></Link>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                    <p>تعداد کل ردیف ها : {count || rows.length}</p>
                    <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} lastPage={lastPage} />
                </div> : <div className="alert alert-info mb-0"><p className="mb-0">تیکتی در سیستم ثبت نشده است</p></div>}
            </div>
        </div>
    )
}

export default Index